export const formBuilderRouteDef = [
    {
        path: 'agentflow',
        component: 'GenericIframeLoaderComponent',
        data: {
            selector: 'app-generic-iframe-loader',
            iframeUrl: `${!window.location.origin.includes('localhost') ? window.location.origin + '/agentic-builder' : 'http://localhost:4300'}/agentflow?id={1}&clientId={2}&apiBaseUrl=${encodeURIComponent(window.location.origin + '/')}&hideNav=true`
        }
    },
    {
        path: ':appId',
        component: 'FormBuilderComponent',
        data: {
            selector: 'app-form-builder',
        }
    }
]
